
import { defineComponent } from "vue"
import AclLayout from "@/js/Layouts/Acl.vue"

export default defineComponent({
    name: "DynamicServicesList",
    components: { AclLayout },
    props: {
        services: {
            type: Array,
            required: true,
        },
    },
})
